import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { WebshopId, WebshopProductModel } from "models/WebShop";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { webShopService } from "services/Services";
import { UrlPath } from "utility/routes";


type BlackFridayLogoDiscountBannerProps = {
    companyId: string;
};


const BlackFridayLogoDiscountBanner = ({companyId}: BlackFridayLogoDiscountBannerProps) => {

    const { companySaleCheck } = useCompanySaleCheck();
    const { saleStatusByCompany } = useOrders();
    const [products, setProducts] = useState<WebshopProductModel[] | undefined>([]);
    const { productConfigurationsByCompany } = useProductConfiguration();

    const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.Logo}`;

    useEffect(() => {
        const getData = async () => {
            const productsList = await webShopService.getProducts();
            if (productsList !== undefined) {
                setProducts(productsList);
            }
        };
        getData();
    }, []);

    if (companyId === "" || companySaleCheck[companyId] === undefined || !companySaleCheck[companyId]?.allowed)
        return <></>;


    

    const canBuy = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses?.some(x => x.activeProducts?.some(p => p.id === WebshopId?.logo)) && productConfigurationsByCompany[companyId]?.logo === null;

    if (!canBuy)

        return <></>;


    const logo = products?.find(x => x.webShopProductId === 101);

    if (logo === null || logo === undefined || logo?.basePrice === logo?.price)
        return <></>;

    return <div className="cc-bw-card-banner"><Link to={path} data-galog="black-week|non-paying|display-promo"><strong>BLACK WEEK!</strong> {Math.floor(((logo.basePrice - logo.price) / logo.basePrice) * 100)}% rabatt ved kjøp av logo - Nå kun {logo.price},- !</Link></div>

}


export default BlackFridayLogoDiscountBanner;